import { GET_STARTED_SOURCE, usePushGetHelp } from "@medbillai/app/lib/usePushGetHelp";
import { Headline1, LoadingButton, Paragraph2, Sparkles, YStack } from "@medbillai/ui";
import { GrantedLogo } from "../../../components/local-images";
export const GettingStartedWidgetV2 = () => {
  const {
    pushGetHelp
  } = usePushGetHelp();
  return <YStack alignItems="center" $platform-web={{
    mt: "$10"
  }} justifyContent="flex-start" gap="$5" data-sentry-element="YStack" data-sentry-component="GettingStartedWidgetV2" data-sentry-source-file="GettingStartedWidgetV2.tsx">
      <GrantedLogo height={88} width={88} data-sentry-element="GrantedLogo" data-sentry-source-file="GettingStartedWidgetV2.tsx" />

      <YStack alignItems="center" gap="$1" data-sentry-element="YStack" data-sentry-source-file="GettingStartedWidgetV2.tsx">
        <Headline1 color="$navy12" data-sentry-element="Headline1" data-sentry-source-file="GettingStartedWidgetV2.tsx">Meet Granted</Headline1>
        <Paragraph2 color="$textSecondary" data-sentry-element="Paragraph2" data-sentry-source-file="GettingStartedWidgetV2.tsx">
          Your AI healthcare assistant
        </Paragraph2>
      </YStack>

      <LoadingButton backgroundColor="$navy12"
    // Optical adjustment: see IssueSummary.tsx for detailed explanation
    paddingRight={14} onPress={() => pushGetHelp({
      caseType: "OTHER",
      title: "Get started with Granted",
      source: GET_STARTED_SOURCE
    })} iconAfter={() => <Sparkles color="$white1" size={18} />} data-sentry-element="LoadingButton" data-sentry-source-file="GettingStartedWidgetV2.tsx">
        Get started
      </LoadingButton>
    </YStack>;
};